/* eslint-disable jsx-a11y/anchor-is-valid */

import NoRecord from "../../../../_metronic/_partials/widgets/NoRecord";
import React, { useEffect, useState } from "react";
import { Table } from "react-bootstrap";
// import { divideByHundred } from "../../../utils/canvaCloseFunction";
import { useIntl } from "react-intl";
import moment from "moment";
import packagingMaterialList from "../../../utils/packagingMaterial.json";
import {
  getMavisPackagingMaterial,
  getStripeSummaryDetails,
} from "../_redux/order/orderCrud";

export function OrderSubscriptionTable({
  orderDetail,
  subDetail,
  setShowIncVat,
}) {
  const intl = useIntl();
  const [listPackage, setListPackage] = useState([]);
  const [listMavisPackage, setListMavisPackage] = useState([]);
  const [stripeSubDetails, setStripeSubDetails] = useState(null);
  const value = orderDetail?.subscription_data;

  const handlePackagingMaterial = () => {
    const matchingItems = [...listPackage];

    packagingMaterialList.forEach((orderItem) => {
      const packItem = orderDetail?.order_summary?.find(
        (packItem) => packItem?.id === orderItem.chargebee_charge_id
      );

      if (packItem) {
        matchingItems.push({
          id: packItem.id,
          name: packItem.name,
          price: packItem.price,
          quantity: packItem.quantity,
          item_price_id: packItem.item_price_id,
        });
      }
    });
    setListPackage(matchingItems);
  };
  const handleMavisPackaging = () => {
    getMavisPackagingMaterial({ order_id: orderDetail?.id }).then((res) => {
      setListMavisPackage(res.data.data);
    });
  };
  useEffect(() => {
    if (orderDetail?.id) {
      handleMavisPackaging();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderDetail?.id]);

  useEffect(() => {
    if (
      orderDetail?.order_summary &&
      orderDetail?.order_summary?.length > 0 &&
      !orderDetail?.packaging_materials
    ) {
      handlePackagingMaterial();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderDetail?.order_summary?.length]);

  useEffect(() => {
    if (orderDetail?.id) {
      getStripeSummaryDetails(orderDetail.id)
        .then((res) => {
          if (res.data && res.data.data) {
            setStripeSubDetails(res.data.data);
            setShowIncVat(true);
          }
        })
        .catch((error) => {
          setStripeSubDetails(null);
        });
    }
  }, [orderDetail?.id]);

  console.log("stripeSubDetails", stripeSubDetails);

  const renderUpcomingInvoice = (upcoming) =>{

    return (
    <>
      {/* Payment Date */}
      <div className="mb-3">
        <p className="mb-1 fs-6">
          <strong>Payment Date:</strong>{" "}
          {upcoming.next_payment
            ? moment(upcoming.next_payment).format("DD-MM-YYYY")
            : "N/A"}
        </p>
      </div>

      {/* Invoice Items */}
      <Table
        responsive
        bordered
        hover
        size="m"
        className="summerytable customColor align-middle shadow-sm"
      >
        <thead className="table-light">
          <tr className="text-center">
            <th>#</th>
            <th>Product</th>
            <th>Description</th>
            <th>Qty</th>
            <th className="text-end">Amount (£)</th>
          </tr>
        </thead>
        <tbody>
          {upcoming.lines?.map((line, idx) => (
            <tr key={idx}>
              <td className="text-center">{idx + 1}</td>
              <td>{line.product}</td>
              <td>{line.description}</td>
              <td className="text-center">{line.quantity}</td>
              <td className="text-end">{Number(line.amount).toFixed(2)}</td>
            </tr>
          ))}

          {/* Item Total */}
          <tr className="table-light fw-semibold" style={{fontWeight: 600}}>
            <td colSpan={4} className="text-end">
              Items Total
            </td>
            <td className="text-end">
              £{Number(upcoming.total_items).toFixed(2)}
            </td>
          </tr>

          {/* Discount Total (if any) */}
          {upcoming.discount_total > 0 && (
            <tr className="table-warning fw-semibold" style={{fontWeight: 600}}>
              <td colSpan={4} className="text-end text-danger">
                Discount
              </td>
              <td className="text-end text-danger">
                -£{Number(upcoming.discount_total).toFixed(2)}
              </td>
            </tr>
          )}

          {/* Final Total */}
          <tr className="table-primary fw-bold" style={{fontWeight: 600}}>
            <td colSpan={4} className="text-end">
              Grand Total (After Discount)
            </td>
            <td className="text-end">
              £{Number(upcoming.total).toFixed(2)}
            </td>
          </tr>
        </tbody>
      </Table>

      {/* Discounts Table */}
      {upcoming.discounts && upcoming.discounts.length > 0 && (
        <Table
          responsive
          bordered
          hover
          size="sm"
          className="summerytable customColor mt-4 align-middle shadow-sm"
        >
          <thead className="table-light">
            <tr className="text-center">
              <th>#</th>
              <th>Coupon Code</th>
              {/* <th>Percent Off</th> */}
              {/* <th>Amount Off</th> */}
            </tr>
          </thead>
          <tbody>
            {upcoming.discounts.map((discount, idx) => (
              <tr key={idx}>
                <td className="text-center">{idx + 1}</td>
                <td>{discount.coupon_code}</td>
                {/* <td className="text-center">
                  {discount.percent_off ? `${discount.percent_off}%` : "-"}
                </td>
                <td className="text-end">
                  {discount.amount_off
                    ? `£${discount.amount_off} ${upcoming.currency}`
                    : "-"}
                </td> */}
              </tr>
            ))}
          </tbody>
        </Table>
      )}
    </>
    );
  }


  return (
    <div className={"customCheck"}>
      {(stripeSubDetails?.items == undefined && stripeSubDetails?.upcoming == undefined) && (
        <Table responsive className="summerytable customColor">
          <thead>
            <tr>
              <th colSpan={2}>{intl.formatMessage({ id: "Product" })}</th>

              <th style={{ textAlign: "right" }}>
                {/* {intl.formatMessage({ id: "Total" })} */}
              </th>
              <th style={{ textAlign: "right" }}>
                {intl.formatMessage({ id: "Qty" })}
              </th>
            </tr>
          </thead>
          <tbody>
            {orderDetail?.order_summary?.length &&
            orderDetail?.is_same_time_return == 1
              ? orderDetail?.order_summary?.map((item, index) => {
                  const insurance = orderDetail?.order_summary.find(
                    (e) =>
                      e.stripe_product_id ===
                      import.meta.env.REACT_APP_PRODUCT_POD_PROTECT
                  );
                  return (
                    <tr key={index}>
                      <td colSpan={2}>{item?.name || "-"} </td>

                      <td className="d-flex"></td>
                      <td style={{ textAlign: "right" }}>
                        {item.name === "Pod Protect"
                          ? "£" + Number(insurance?.cover).toFixed(0)
                          : item?.quantity || "-"}{" "}
                      </td>
                    </tr>
                  );
                })
              : orderDetail?.packaging_materials &&
                orderDetail?.packaging_materials?.length > 0
              ? ""
              : ""
            }
            {orderDetail?.is_same_time_return != 1 &&
              orderDetail?.subscription_id &&
              orderDetail?.subscription_id.includes("sub_") && (
                <>
                  {subDetail?.items?.data?.map((item, index) => {
                    const insurance =
                      orderDetail?.order_summary?.length &&
                      orderDetail?.order_summary?.find(
                        (e) =>
                          e.stripe_product_id ===
                          import.meta.env.REACT_APP_PRODUCT_POD_PROTECT
                      );
                    return (
                      <tr key={index}>
                        <td colSpan={2}>{item?.plan?.product_name || "-"} </td>

                        <td className="d-flex"></td>
                        <td style={{ textAlign: "right" }}>
                          {item?.plan.product_name === "Pod Protect" ||
                          item?.plan?.product_name === "Store Protect"
                            ? "£" +
                              Number(
                                orderDetail?.insurance_cover || insurance?.cover
                              ).toLocaleString()
                            : item?.quantity || "-"}{" "}
                        </td>
                      </tr>
                    );
                  })}
                </>
              )}

            {orderDetail?.is_same_time_return != 1 &&
            (!orderDetail?.subscription_id ||
              !orderDetail?.subscription_id.includes("sub_")) ? (
              orderDetail.subscription_scheduled_id ? (
                <>
                  {value?.phases && value?.phases?.length ? (
                    value?.phases[0]?.items?.map((item, index) => {
                      const insurance =
                        orderDetail?.order_summary?.length &&
                        orderDetail?.order_summary?.find(
                          (e) =>
                            e.stripe_product_id ===
                            import.meta.env.REACT_APP_PRODUCT_POD_PROTECT
                        );
                      return (
                        <tr key={index}>
                          <td colSpan={2}>{item?.product_name || "-"} </td>

                          <td className="d-flex"></td>
                          <td style={{ textAlign: "right" }}>
                            {item.product_name === "Pod Protect"
                              ? "£" +
                                Number(
                                  orderDetail?.insurance_cover ||
                                    insurance?.cover
                                ).toLocaleString()
                              : item?.quantity || "-"}{" "}
                          </td>
                        </tr>
                      );
                    })
                  ) : orderDetail?.packaging_materials &&
                    orderDetail?.packaging_materials?.length > 0 ? (
                    ""
                  ) : (
                    <tr>
                      <td colSpan={"5"}>
                        <>
                          <NoRecord />
                        </>
                        {/* )} */}
                      </td>
                    </tr>
                  )}
                </>
              ) : (
                <>
                  {value?.items?.data && value?.items?.data.length ? (
                    value?.items?.data.map((item, index) => {
                      const insurance =
                        orderDetail?.order_summary?.length &&
                        orderDetail?.order_summary?.find(
                          (e) =>
                            e.stripe_product_id ===
                            import.meta.env.REACT_APP_PRODUCT_POD_PROTECT
                        );
                      return (
                        <tr key={index}>
                          <td colSpan={2}>
                            {item?.plan?.product_name || "-"}{" "}
                          </td>

                          <td className="d-flex"></td>
                          <td style={{ textAlign: "right" }}>
                            {item?.plan?.product_name === "Pod Protect"
                              ? "£" +
                                Number(
                                  orderDetail?.insurance_cover ||
                                    insurance?.cover
                                ).toLocaleString()
                              : item?.quantity || "-"}{" "}
                          </td>
                        </tr>
                      );
                    })
                  ) : orderDetail?.packaging_materials &&
                    orderDetail?.packaging_materials?.length > 0 ? (
                    ""
                  ) : (
                    <tr>
                      <td colSpan={"5"}>
                        <>
                          <NoRecord />
                        </>
                        {/* )} */}
                      </td>
                    </tr>
                  )}
                </>
              )
            ) : (
              ""
            )}
          </tbody>
        </Table>
      )}


    {stripeSubDetails?.upcoming && renderUpcomingInvoice(stripeSubDetails?.upcoming)}

      {stripeSubDetails?.items && (
        <Table responsive className="summerytable customColor">
          <thead>
            <tr>
              <th colSpan={2}>{intl.formatMessage({ id: "Product" })}</th>
              <th style={{ textAlign: "right" }}>
                {intl.formatMessage({ id: "Qty" })}
              </th>
              <th style={{ textAlign: "right" }}>Unit Price</th>
              <th style={{ textAlign: "right" }}>Discount</th>
              <th style={{ textAlign: "right" }}>Total</th>
            </tr>
          </thead>
          <tbody>
            {stripeSubDetails?.items?.map((item, index) => {
              const quantity = item?.quantity || 0;
              const price = item?.unit_price || 0;
              const discount = item?.discount || 0;
              const total = price * quantity - discount; // Subtract discount here

              return (
                <tr key={index}>
                  <td colSpan={2}>
                    {item?.product_name || "-"}
                    {(item?.product_name === "Pod Protect" ||
                      item?.product_name === "Store Protect") && (
                      <div style={{ fontSize: "0.85em", color: "#000" }}>
                        <strong>
                          £
                          {Number(
                            orderDetail?.insurance_cover
                          ).toLocaleString()}
                        </strong>
                      </div>
                    )}
                  </td>
                  <td style={{ textAlign: "right" }}>{quantity}</td>
                  <td style={{ textAlign: "right" }}>£{price.toFixed(2)}</td>
                  <td style={{ textAlign: "right" }}>
                    {discount > 0 ? `-£${discount.toFixed(2)}` : "-"}
                  </td>
                  <td style={{ textAlign: "right" }}>£{total.toFixed(2)}</td>
                </tr>
              );
            })}

            {/* Grand Total Row */}
            <tr>
              <td
                colSpan={5}
                style={{ textAlign: "right", fontWeight: "bold" }}
              >
                Grand Total
              </td>
              <td style={{ textAlign: "right", fontWeight: "bold" }}>
                £
                {stripeSubDetails.items
                  ?.reduce((sum, item) => {
                    const qty = item?.quantity || 0;
                    const price = item?.unit_price || 0;
                    const discount = item?.discount || 0;
                    return sum + price * qty - discount; // Subtract discount here too
                  }, 0)
                  .toFixed(2)}
              </td>
            </tr>
          </tbody>
        </Table>
      )}

      {(orderDetail?.packaging_materials &&
        orderDetail?.packaging_materials?.length > 0) ||
      (listPackage && listPackage?.length > 0) ||
      (listMavisPackage && listMavisPackage?.length > 0) ? (
        <>
          <h5 className="card-title align-items-start flex-column">
            <span className="font-weight-bolder text-dark">
              Packaging Material{" "}
              <span style={{ fontSize: "14px" }}>
                {orderDetail?.is_ship_materials === 1
                  ? "(shipped)"
                  : "(not shipped)"}
              </span>
            </span>
          </h5>
          <Table responsive className="summerytable customColor">
            <thead>
              <tr>
                <th colSpan={2}>{intl.formatMessage({ id: "Product" })}</th>

                <th style={{ textAlign: "right" }}>
                  {/* {intl.formatMessage({ id: "Total" })} */}
                </th>
                <th style={{ textAlign: "right" }}>
                  {intl.formatMessage({ id: "Qty" })}
                </th>
              </tr>
            </thead>
            <tbody>
              {listMavisPackage && listMavisPackage.length > 0
                ? listMavisPackage.map((item, index) => (
                    <tr key={index}>
                      <td colSpan={2}>{item?.name || "-"}</td>
                      <td className="d-flex"></td>
                      <td style={{ textAlign: "right" }}>{item?.qty || ""}</td>
                    </tr>
                  ))
                : ""}
            </tbody>
          </Table>
        </>
      ) : (
        ""
      )}
    </div>
  );
}
